// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';

import Autocomplete from 'react-google-autocomplete';
import { HourPicker } from '../../Elements/Pickers';
import { isMobile } from '../../../utils';

import DatePicker from 'react-datepicker';
// import DateRangePicker from 'react-bootstrap-daterangepicker'
// import TimePicker from 'react-bootstrap-time-picker';

import moment from 'moment';

// INNER IMPORTS
import "react-datepicker/dist/react-datepicker.css";
import './MusicLiveForm.css';

const MusicLiveForm = props => {
    const renderMobile = () => {
        return (
            <div className="musicLiveForm rtl">
                <div className="leftPart">
                    <input
                        type="text"
                        name="name"
                        placeholder="שם אירוע/ אמן/ להקה?"
                        onChange={props.updateValue}
                        value={props.name || ''}
                        className={(props.userShouldEnter && props.userShouldEnter.indexOf("name") >- 1 ? "required" : null)}
                    />

                    <Autocomplete
                        id="autocomplete"
                        onPlaceSelected={(place) => {props.updateLocation(place)}}
                        types={['geocode', 'establishment']}
                        className={(props.userShouldEnter && props.userShouldEnter.indexOf("location")>-1?"required":null)}
                        placeholder="איפה?"
                        language="iw"
                    />
                    <div className={`location-msg ${props.isLocationMsg ? 'show' : ''}`}>Note: For showing up on map - Add a street name</div>

                    <div className="date-selector-top-wrapper">
                        <DatePicker
                            selected={props.date ? moment(props.date) : null}
                            onChange={props.updateDate}
                            minDate={moment()}
                            placeholderText="מתי?"
                            className={`date-selector ${(props.userShouldEnter && props.userShouldEnter.indexOf("date") > - 1 ? "required" : null)}`}
                        />
                    </div>

                    <HourPicker time={props.time}  updateTime={props.updateTime} userShouldEnter={props.userShouldEnter} />
                </div>
                <div className="rightPart">
                    <textarea
                        type="text"
                        name="desc"
                        onChange={props.updateValue}
                        placeholder="עוד משהו?"
                        value={props.desc}
                        maxLength="5000"
                    />
                    {/*<TimePicker value={props.time || 75600} step={30} onChange={props.updateTime} format={24}/>*/}
                    {/*<textarea name="contactInfo" placeholder="Contact info?" onChange={props.updateValue} value={props.contactInfo} maxLength="100"/>*/}
                </div>
            </div>
        )
    }

    // Note: For showing up on map - Add a street name
    // Event name / Artist / Band?
    const renderWeb = () => {
        return (
            <div className="musicLiveForm rtl">
                <div className="leftPart">
                    <input type="text" name="name" placeholder="שם אירוע/ אמן/ להקה?" onChange={props.updateValue} value={props.name || ''}
                           className={(props.userShouldEnter && props.userShouldEnter.indexOf("name") >- 1 ? "required" : null)}/>
                    <textarea
                        type="text"
                        name="desc"
                        onChange={props.updateValue}
                        placeholder="עוד משהו?"
                        value={props.desc}
                        maxLength="5000"/>
                </div>
                <div className="rightPart">
                    <Autocomplete
                        id="autocomplete"
                        onPlaceSelected={(place) => {props.updateLocation(place)}}
                        types={['geocode', 'establishment']}
                        placeholder="הכניסו מיקום"
                        className={(props.userShouldEnter && props.userShouldEnter.indexOf("location")>-1?"required":'')}
                    />
                    <div className={`location-msg ${props.isLocationMsg ? 'show' : ''}`}>הערה: על מנת להציג במפה - הוסיפו שם רחוב</div>

                    <div className="date-selector-top-wrapper">
                        <DatePicker
                            selected={props.date ? moment(props.date) : null}
                            onChange={props.updateDate}
                            minDate={moment()}
                            placeholderText="מתי?"
                            className={`submit date-selector ${(props.userShouldEnter && props.userShouldEnter.indexOf("date") > - 1 ? "required" : '')}`}
                        />
                    </div>

                    <HourPicker time={props.time}  updateTime={props.updateTime} userShouldEnter={props.userShouldEnter} />
                    {/*<TimePicker value={props.time || 75600} step={30} onChange={props.updateTime} format={24}/>*/}
                    {/*<textarea name="contactInfo" placeholder="Contact info?" onChange={props.updateValue} value={props.contactInfo} maxLength="100"/>*/}

                    {/*<div className="is-repeat-wrapper">*/}
                    {/*    <input*/}
                    {/*        disabled*/}
                    {/*        type="text"*/}
                    {/*        name="is_repeat"*/}
                    {/*        placeholder="Repeat every week?"*/}
                    {/*        onChange={() => {}}*/}
                    {/*        className={'is-repeat'}*/}
                    {/*    />*/}
                    {/*    <div onClick={() => toggleIsRepeatClick()} className={`toggle-btn left ${props.isRepeat ? 'active' : ''}`}>Yes</div>*/}
                    {/*    <div onClick={() => toggleIsRepeatClick()} className={`toggle-btn ${!props.isRepeat ? 'active' : ''}`}>No</div>*/}
                    {/*</div>*/}

                </div>
            </div>
        )
    }

    return isMobile() ? renderMobile() : renderWeb();
};

MusicLiveForm.propTypes = {
    time: PropTypes.number,
    desc: PropTypes.string,
    date: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    isLocationMsg: PropTypes.string,
    userShouldEnter: PropTypes.array,
    name: PropTypes.string,
    updateTime: PropTypes.func,
    updateDate: PropTypes.func,
    updateLocation: PropTypes.func,
    isSignupModalOpen: PropTypes.bool,
    isRepeat: PropTypes.bool
};

export default MusicLiveForm;



// WEBPACK FOOTER //
// ./src/Components/Users/Submit/MusicLiveForm.js